/*
  Add-on orphan guard
  The engraving product is only meant to be bought as a nested line
  (parent_relationship) attached to a main product. If a standalone
  engraving line ever reaches the cart (direct link, old cart, etc.),
  remove it and tell the shopper.
  Variant ids come from <script type="application/json" id="x-addon-guard-data">.
*/
if (!window.TLAddonOrphanGuard) {
  window.TLAddonOrphanGuard = (() => {
    let running = false;

    function addonVariantIds() {
      const node = document.getElementById('x-addon-guard-data');
      if (!node) return [];
      try {
        const data = JSON.parse(node.textContent || '{}');
        return (data.variantIds || []).filter(Boolean).map(Number);
      } catch (error) {
        return [];
      }
    }

    function isNested(item) {
      const rel = item.parent_relationship;
      return Boolean(rel && (rel.parent_key || rel.parent));
    }

    function showNotice() {
      const target = document.querySelector('.cart-total-summary') ||
        document.querySelector('.cart-drawer-price-total') ||
        document.getElementById('main-cart-footer') ||
        document.getElementById('main-cart-items');
      if (!target) return;
      document.querySelectorAll('.x-addon-orphan-notice').forEach((n) => n.remove());
      const notice = document.createElement('div');
      notice.className = 'x-addon-orphan-notice';
      notice.setAttribute('role', 'status');
      notice.style.cssText = 'margin:0 0 12px;padding:10px 14px;border:1px solid rgba(183,110,60,.4);border-left:4px solid #b76e3c;border-radius:8px;background:rgba(183,110,60,.07);font-size:13px;line-height:1.45;';
      notice.textContent = 'Engraving can only be added together with a product. It was removed from your cart — turn on “Personalize with engraving” on the product page instead.';
      target.insertAdjacentElement('afterbegin', notice);
    }

    async function check() {
      if (running || window.updatingCart) return;
      const ids = addonVariantIds();
      if (!ids.length) return;
      running = true;
      try {
        const cart = await fetch(`${Shopify.routes.root}cart.js`, {
          headers: { Accept: 'application/json' }
        }).then((r) => r.json());
        const orphans = (cart.items || []).filter((item) =>
          ids.includes(Number(item.variant_id)) && !isNested(item)
        );
        if (!orphans.length) return;

        const updates = {};
        orphans.forEach((item) => { updates[item.key] = 0; });
        const sections = window.Alpine?.store('xCartHelper')?.getSectionsToRender
          ? Alpine.store('xCartHelper').getSectionsToRender().map((s) => s.id)
          : [];
        window.updatingCart = true;
        const res = await fetch(`${Shopify.routes.root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates, sections, sections_url: window.location.pathname })
        });
        const state = await res.json();
        window.updatingCart = false;
        if (window.Alpine?.store('xCartHelper')?.reRenderSections) {
          await Alpine.store('xCartHelper').reRenderSections(state.sections);
        } else if (/\/cart\/?$/.test(window.location.pathname)) {
          window.location.reload();
          return;
        }
        window.Alpine?.store('xCartNoti')?.applyCart?.(state);
        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
        showNotice();
      } catch (error) {
        console.error('Addon guard:', error);
      } finally {
        window.updatingCart = false;
        running = false;
      }
    }

    window.addEventListener('load', () => setTimeout(check, 300));
    document.addEventListener('eurus:cart:items-changed', () => setTimeout(check, 150));
    document.addEventListener('eurus:cart:add', () => setTimeout(check, 150));

    return { check };
  })();
}
